<div
  class="card-container ability"
  [ngClass]="{
    fh: settingsManager.settings.fhStyle,
    bb: settingsManager.settings.theme === 'bb',
    expand: flipped() || (abilityCard && abilityCard.revealed)
  }"
  [style.--ghs-ability-color]="character && character.color"
>
  <div
    class="card"
    [ngClass]="{ flipped: flipped() || (abilityCard && abilityCard.revealed) }"
    card-reveal
    (changed)="onChange($event)"
    [disabled]="!reveal() || !abilityCard"
    #card
  >
    <div
      class="card-back ability-back"
      [ngClass]="{
        'bottom-actions': abilityCard && abilityCard.bottomActions && abilityCard.bottomActions.length > 0 && !character,
        'character-actions': character
      }"
    >
      <div class="touch"></div>
      <span class="revealed"><span class="text" [ghs-label]="'game.cards.confirmReveal'"></span></span>
      @if (!!monster) {
        <span class="name" [ghs-label]="deckLabel"></span>
      }
      @if (!!character) {
        <span class="name"><span [ghs-label]="'data.character.' + character.edition + '.' + character.name"></span></span>
      }
      @if (!!character) {
        <span class="logo"><img [src]="character.iconUrl" /></span>
      }
    </div>
    <div
      class="card-front ability-front"
      [ngClass]="{
        'bottom-actions': abilityCard && abilityCard.bottomActions && abilityCard.bottomActions.length > 0 && !character,
        'character-actions': character
      }"
    >
      @if (!!abilityCard) {
        @if (identityColor) {
          <div class="identity-tint" [style.background-color]="identityColor"></div>
        }
        @if (identityIcon) {
          <div class="identity-frame" [ngClass]="'identity-' + abilityCard.identity">
            <svg viewBox="-130 -10 210 304" preserveAspectRatio="none">
              <polygon points="-120,142 -50,0 70,0 0,142 70,284 -50,284" />
            </svg>
            <img [src]="identityIcon" />
          </div>
        }
        @if (identityInitiatives.length) {
          <div class="initiative identity-initiatives">
            @for (identityInitiative of identityInitiatives; track identityInitiative.identity; let first = $first) {
              <span class="identity-initiative" [ngClass]="{ first: first }" [style.--ghs-identity-color]="identityInitiative.color">
                <img [src]="identityInitiative.icon" />
                <span class="identity-initiative-value">
                  @if (identityInitiative.initiative < 10) {
                    <span>0</span>
                  }
                  {{ identityInitiative.initiative }}
                </span>
              </span>
            }
          </div>
        } @else {
          <div class="initiative">
            @if (abilityCard.initiative < 10) {
              <span>0</span>
            }
            {{ abilityCard.initiative }}
            @if (identityIcon) {
              <img class="identity" [ngClass]="'identity-' + abilityCard.identity" [src]="identityIcon" />
            }
          </div>
        }
        <span class="name">{{ abilityLabel }}</span>
        <div class="ability-actions-container" [ngClass]="{ disabled: activeActions() && activeActions() === 'bottom' }">
          <div class="ability-actions">
            <ghs-actions
              [actions]="abilityCard.actions"
              [monster]="monster"
              [character]="character"
              [statsCalculation]="statsCalculation()"
              [shieldStats]="settingsManager.settings.calculateShieldStats"
              [relative]="relative()"
              [interactiveAbilities]="interactiveAbilities()"
              [(interactiveActions)]="interactiveActions"
              [cardId]="abilityCard.cardId"
            >
            </ghs-actions>
          </div>
          @if (
            interactiveActions.length || (settingsManager.settings.interactiveAbilities && settingsManager.settings.showExpandedAbilityCard)
          ) {
            <div class="bottom-spacer"></div>
          }
        </div>
        @if (interactiveAbilities() && !!monster && (!activeActions() || (activeActions() && activeActions() === 'top'))) {
          <ghs-interactive-actions
            [ngClass]="{ 'interactive-actions-top': (abilityCard.bottomActions && abilityCard.bottomActions.length > 0) || character }"
            [figure]="monster"
            [actions]="abilityCard.actions"
            [(interactiveActions)]="interactiveActions"
          ></ghs-interactive-actions>
        }
        @if ((!!abilityCard.bottomActions && abilityCard.bottomActions.length > 0) || character) {
          <span class="level">
            <span class="text" [ghs-label]="abilityCard.level || 0"></span>
          </span>
          <div class="ability-actions-container" [ngClass]="{ disabled: activeActions() && activeActions() === 'top' }">
            <div class="ability-actions ability-bottom-actions">
              <ghs-actions
                [actions]="abilityCard.bottomActions"
                [monster]="monster"
                [character]="character"
                [statsCalculation]="statsCalculation()"
                [shieldStats]="shieldStats"
                [relative]="relative()"
                [interactiveAbilities]="interactiveAbilities()"
                [(interactiveActions)]="interactiveBottomActions"
                [index]="'bottom'"
                [cardId]="abilityCard.cardId"
              >
              </ghs-actions>
            </div>
          </div>
          @if (interactiveAbilities() && !!monster && (!activeActions() || (activeActions() && activeActions() === 'bottom'))) {
            <ghs-interactive-actions
              class="interactive-actions-bottom"
              [figure]="monster"
              [actions]="abilityCard.bottomActions"
              [(interactiveActions)]="interactiveBottomActions"
              [preIndex]="'bottom'"
            ></ghs-interactive-actions>
          }
        }
        @if (abilityCard.shuffle) {
          <div class="shuffle"><img src="./assets/images/shuffle.svg" /></div>
        }
        @if (abilityCard.bottomShuffle) {
          <div class="bottom-shuffle"><img src="./assets/images/shuffle.svg" /></div>
        }
        @if (!abilityCard.cardId && settingsManager.settings.abilityNumbers) {
          <span class="index">[{{ abilityIndex + 1 }}]</span>
        }
        @if (abilityCard.cardId && settingsManager.settings.abilityNumbers) {
          <span class="index">
            @if (!!character && abilityCard.cardId < 100) {
              <span>0</span>
            }
            @if (!!character && abilityCard.cardId < 10) {
              <span>0</span>
            }
            <span>{{ abilityCard.cardId }}</span>
          </span>
        }
        @if (!!character) {
          <span class="logo"><img [src]="character.iconUrl" /></span>
        }
        @if (abilityCard.lost || abilityCard.persistent || abilityCard.loss || abilityCard.round || abilityCard.xp) {
          <div class="required-container">
            <span class="label">!</span>
            <div class="box">
              @if (abilityCard.xp) {
                <span class="xp">
                  <img src="./assets/images/action/card/experience.svg" />
                  <span class="value">{{ abilityCard.xp }}</span>
                </span>
              }
              @if (abilityCard.persistent) {
                <span class="persistent">
                  <img src="./assets/images/action/card/persistent.svg" />
                  <img class="overlay" src="./assets/images/action/card/overlay/persistent.svg" />
                </span>
              }
              @if (abilityCard.loss) {
                <span class="loss">
                  <img src="./assets/images/action/card/loss.svg" />
                  <img class="overlay" src="./assets/images/action/card/overlay/loss.svg" />
                </span>
              }
              @if (abilityCard.round) {
                <span class="round">
                  <img src="./assets/images/action/card/round.svg" />
                  <img class="overlay" src="./assets/images/action/card/overlay/round.svg" />
                </span>
              }
              @if (abilityCard.lost) {
                <span class="lost">
                  <img src="./assets/images/action/card/lost.svg" />
                  <img class="overlay" src="./assets/images/action/card/overlay/lost.svg" />
                </span>
              }
            </div>
          </div>
        }
        @if (
          abilityCard.bottomLost ||
          abilityCard.bottomPersistent ||
          abilityCard.bottomLoss ||
          abilityCard.bottomRound ||
          abilityCard.bottomXp
        ) {
          <div class="required-container bottom">
            <span class="label">!</span>
            <div class="box">
              @if (abilityCard.bottomXp) {
                <span class="xp">
                  <img src="./assets/images/action/card/experience.svg" />
                  <span class="value">{{ abilityCard.bottomXp }}</span>
                </span>
              }
              @if (abilityCard.bottomPersistent) {
                <span class="persistent">
                  <img src="./assets/images/action/card/persistent.svg" />
                  <img class="overlay" src="./assets/images/action/card/overlay/persistent.svg" />
                </span>
              }
              @if (abilityCard.bottomLoss) {
                <span class="loss">
                  <img src="./assets/images/action/card/loss.svg" />
                  <img class="overlay" src="./assets/images/action/card/overlay/loss.svg" />
                </span>
              }
              @if (abilityCard.bottomRound) {
                <span class="round">
                  <img src="./assets/images/action/card/round.svg" />
                  <img class="overlay" src="./assets/images/action/card/overlay/round.svg" />
                </span>
              }
              @if (abilityCard.bottomLost) {
                <span class="lost">
                  <img src="./assets/images/action/card/lost.svg" />
                  <img class="overlay" src="./assets/images/action/card/overlay/lost.svg" />
                </span>
              }
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
